module.exports = __webpack_public_path__ + "static/media/404.bc8dc592.png";